import type { Efficiency } from './efficiency';
import type { Distribution } from './distribution';
import { SessionTypes } from '../../enums/session-types';
import type { TimeSaved } from './time-saved';
import { TimeIntervals } from '../../enums/time-intervals';

enum AdditionalReportType {
  ALL_INTEGRATIONS = 'ALL_INTEGRATIONS',
}

export const ReportTypes = {
  ...SessionTypes,
  ...AdditionalReportType,
};

export type ReportTypes = SessionTypes | AdditionalReportType;

/**
 * Type of report connection (Help/Contact/Chat/Assist)
 */
type ReportConnection = {
  id: number;
  categories: Array<string>;
  language: string;
} | null;

/**
 * Type of feedback data
 */
export type FeedbackData = {
  id: number;
  name: string;
  negative: number;
  negativePercent: number;
  neutral: number;
  neutralPercent: number;
  positive: number;
  positivePercent: number;
  total: number;
  sufficient?: boolean;
};

/**
 * Type of report data
 */
type ReportData = {
  categories: any;
  efficiency: Efficiency;
  questions: Array<Distribution>;
  timeline: {
    solvedAbsolute: Array<number>;
    solvedFilteredAbsolute: Array<number>;
    totalAbsolute: Array<number>;
  };
  timeSaved: TimeSaved;
  feedbacks: Array<FeedbackData>;
  languages?: Array<any>;
  channels?: Array<any>;
  feedback?: any;
};

/**
 * Type of report.
 */
export type Report = {
  type: ReportTypes;
  connection: ReportConnection;
  data: ReportData;
  timeInterval: TimeIntervals;
};
